import { METRIC_NAMES } from '@config/Consts';
import { RESOURCES as REPORTING_RESOURCES } from '@core/clients/ReportingClient';
import { RESOURCES as AGENT_MANAGER_RESOURCES } from '@core/clients/AgentManagerClient';
import QueueHealthModel from '@core/models/SkillQueueHealthModel';
import SkillManagerMetricsModel from '@core/models/SkillManagerMetricsModel';

const SKILL_LIST_RESOURCES = {
  METRICS: AGENT_MANAGER_RESOURCES.METRICS,
  MESSAGING_CURRENT_QUEUE_HEALTH: REPORTING_RESOURCES.MESSAGING_CURRENT_QUEUE_HEALTH,
};

const RESOURCES_METRICS_MAP = {
  [REPORTING_RESOURCES.MESSAGING_CURRENT_QUEUE_HEALTH]: [
    METRIC_NAMES.OVERDUE_TOTAL,
    METRIC_NAMES.ACTIONABLE,
    METRIC_NAMES.OVERDUE_ASSIGNED,
    METRIC_NAMES.CONVERSATION_IN_QUEUE_WAIT_TIME,
  ],
  [AGENT_MANAGER_RESOURCES.METRICS]: [
    METRIC_NAMES.SKILLS_SKILL_NAME,
    METRIC_NAMES.SKILL_ASSIGNED_CONVERSATIONS,
    METRIC_NAMES.SKILL_LOAD,
    METRIC_NAMES.SKILL_ONLINE_AGENTS,
    METRIC_NAMES.SKILL_AWAY_AGENTS,
    METRIC_NAMES.SKILL_BACK_SOON_AGENTS,
    METRIC_NAMES.SKILL_CLOSED_CONVERSATIONS,
    METRIC_NAMES.AVG_WAIT_TIME,
    METRIC_NAMES.AVG_WAIT_TIME_FIRST_RESPONSE,
    METRIC_NAMES.AVG_TIME_TO_RESPONSE,
    METRIC_NAMES.AVG_TIME_TO_FIRST_RESPONSE_FIRST_ASSIGNMENT,
    //
    METRIC_NAMES.OVERDUE_IN_QUEUE,
    METRIC_NAMES.SKILL_UNASSIGNED_CONVERSATIONS,
    METRIC_NAMES.SKILL_WAIT_TIME_AGENT_ASSIGNMENT_50_PERCENTILE,
    METRIC_NAMES.SKILL_WAIT_TIME_AGENT_ASSIGNMENT_90_PERCENTILE,
  ],
};

const RESOURCES_MODEL_MAP = {
  [REPORTING_RESOURCES.MESSAGING_CURRENT_QUEUE_HEALTH]: QueueHealthModel,
  [AGENT_MANAGER_RESOURCES.METRICS]: SkillManagerMetricsModel,
};

export {
  RESOURCES_MODEL_MAP,
  RESOURCES_METRICS_MAP,
  SKILL_LIST_RESOURCES,
};
